"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouteAction = void 0;
const react_1 = require("react");
const react_2 = require("react");
const query_params_util_1 = require("../../@common/util/query-params-util");
const util_1 = require("./util");
const use_modal_1 = __importDefault(require("./use-modal"));
const useRouteAction = (callback) => {
    const [ui] = use_modal_1.default();
    const { action: routeAction } = query_params_util_1.parseQueryParams(window.location.search) || {};
    /** using dispatch here to have current ref of 'callback' */
    const reducer = (state, action) => {
        switch (action.type) {
            case 'NOTIFY_ROUTE_ACTION_MODAL_LISTENER': {
                const payload = {
                    action: util_1.getModalRouteActionValue(action.payload),
                    type: util_1.RouteAction.MODAL_TYPE,
                    params: util_1.parseActionRouteParams(window.location.search)
                };
                callback && callback(payload);
                return payload;
            }
            default:
                return { action: null, type: null };
        }
    };
    const [state, dispatch] = react_1.useReducer(reducer, {
        action: null,
        type: null
    });
    react_2.useEffect(() => {
        if (routeAction && state.action !== routeAction) {
            if (routeAction.includes(util_1.getModalActionKey()) && !ui.isOpen && !ui.isRouteActionChanging) {
                dispatch({
                    type: 'NOTIFY_ROUTE_ACTION_MODAL_LISTENER',
                    payload: Array.isArray(routeAction) ? routeAction.join(',') : routeAction
                });
            }
            /**
             * ...more potential non-modal actions here...
             */
        }
    }, [routeAction, ui.isOpen, ui.isRouteActionChanging, state.action]);
};
exports.useRouteAction = useRouteAction;
exports.default = exports.useRouteAction;
